<template>
    <div v-if="errors.length || Object.keys(errors).length" class="alert alert-danger" role="alert">
        <strong>The following error was found in your file:</strong>
        <hr>
        <div v-for="(errorObject, index) in errors" :key="index">
            <dl v-if="errorObject instanceof Object && !(errorObject instanceof Array)" class="dl-horizontal">
                <div v-for="(value, key, i) in errorObject" :key="i">
                    <dt>{{ key }}</dt>
                    <dd>{{ value }}</dd>
                </div>
            </dl>
            <div v-else>
                {{ errorObject }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FileUploaderErrorDisplay",
    props: {
        errors: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
}
</script>
